import {makeAutoObservable} from "mobx";
import User from "./domain/User";
import {AppConfig} from "./AppConfig";
import {AuthenticatedAppConfig} from "./AuthenticatedAppConfig";
import dayjs from "dayjs";

export class AppContext {

    public language = "cs";

    public user?: User;

    public lastActivity?: Date;

    public sessionExpiresAt?: Date;

    public config?: AppConfig;

    public isTabletOrMobile?: boolean;

    public actionConfirmationCode?: string;

    public authenticatedConfig?: AuthenticatedAppConfig;

    public serviceWorkerRegistration?: ServiceWorkerRegistration;

    public overlayVisible = false;

    constructor() {
        makeAutoObservable(this);
    }

    public get expiresInSeconds() {
        return dayjs(this.sessionExpiresAt).diff(dayjs(), 'second');
    }

}
